export default __webpack_public_path__ + "static/media/delosi.3f456325.jpg";